import Vue from 'vue'
// import Keyboard from './keyboard'
import Global from './global'
import Directives from '@/directives'
import { CloseToRefreshList } from '@/mixins'
Vue.use(Global)
Vue.use(Directives)
// Vue.use(Keyboard)
Vue.mixin(CloseToRefreshList)
